import { c as _c } from "react/compiler-runtime";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import ProfileActivityLogs from "@/components/profile-activity/ProfileActivityLogs";
import ProfileName, { ProfileNameType } from "@/components/profile-activity/ProfileName";
import UserTableHeaderWrapper from "../utils/UserTableHeaderWrapper";
export default function UserPageRepActivityLog(t0) {
  const $ = _c(3);
  const {
    initialActivityLogParams
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <UserTableHeaderWrapper><span><ProfileName type={ProfileNameType.POSSESSION} /></span>{" "}Rep Activity Log</UserTableHeaderWrapper>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== initialActivityLogParams) {
    t2 = <div>{t1}<div className="tw-mt-2 lg:tw-mt-4"><div className="tw-bg-iron-950 tw-border tw-border-iron-800 tw-border-solid tw-rounded-xl"><ProfileActivityLogs initialParams={initialActivityLogParams} withFilters={false} /></div></div></div>;
    $[1] = initialActivityLogParams;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}